import React, { VFC } from 'react'

type Props = { className?: string }

export const InfoTriangleIcon: VFC<Props> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 18 16"
      fill="#FF005C"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5504 1.25268C9.86488 0.0529797 8.13501 0.0529791 7.44946 1.25268L1.00257 12.5347C0.322292 13.7252 1.1819 15.2065 2.55305 15.2065H15.4468C16.818 15.2065 17.6776 13.7252 16.9973 12.5347L10.5504 1.25268ZM7.74994 12.1667C7.74994 12.857 8.30959 13.4167 8.99994 13.4167C9.6903 13.4167 10.2499 12.857 10.2499 12.1667V12.1176C10.2499 11.4273 9.6903 10.8676 8.99994 10.8676C8.30959 10.8676 7.74995 11.4273 7.74994 12.1176V12.1667ZM7.74995 8.22548C7.74994 8.91583 8.30959 9.47548 8.99995 9.47548C9.6903 9.47548 10.2499 8.91583 10.2499 8.22548V4.22548C10.2499 3.53512 9.6903 2.97548 8.99995 2.97548C8.30959 2.97548 7.74995 3.53512 7.74995 4.22548V8.22548Z"
      />
    </svg>
  )
}
